<template>
    <div id="footer">
                <a>Site réalisé par
                <img src="../assets/logo_ducre.jpg" alt="Pied de page" style="width: 52.26px; height: 18px;" />
                    DUCRE ENERGIE S.A.R.L. - © Copyright DUCRE ENERGIE S.A.R.L., 2013-2023. All rights reserved R3.14
                <router-link id="ctl00_lnkHome" class="a" to="/Legal">Mentions Légales</router-link>
                </a>

            </div>
</template>